import http from '@/http-common'

class ServiziDataService {
  getServizioById (id) {
    return http.get(`servizio/${id}`)
  }

  getServiziByCommuneId (id) {
    return http.get(`comune/${id}/servizi`)
  }

  insertToComune (id, data) {
    return http.post(`comune/${id}/servizio`, data)
  }

  update (id, data) {
    return http.put(`servizio/${id}`, data)
  }

  delete (id) {
    return http.delete(`Servizi/${id}`)
  }

  insertContatto (id, data) {
    return http.post(`servizio/${id}/contatto`, data)
  }
}

export default new ServiziDataService()
